import { render, staticRenderFns } from "./TheCorpoChat.vue?vue&type=template&id=77e8b3d8&scoped=true"
import script from "./TheCorpoChat.vue?vue&type=script&lang=js"
export * from "./TheCorpoChat.vue?vue&type=script&lang=js"
import style0 from "./TheCorpoChat.vue?vue&type=style&index=0&id=77e8b3d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e8b3d8",
  null
  
)

export default component.exports